/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum KycFileCertificationStatus {
    UNCERTIFIED = 'UNCERTIFIED',
    SELF_ATTESTED = 'SELF_ATTESTED',
    PENDING_CERTIFIER = 'PENDING_CERTIFIER',
    CERTIFIED = 'CERTIFIED',
}
